import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { FirebaseAuthService } from './firebase-auth.service';

/**
 * HTTP interceptor that adds Firebase authentication token to all HTTP requests.
 *
 * This is separate from the grpc-web AuthInterceptor.
 * Used for REST/SSE endpoints like ChatService.
 */
@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  private authService = inject(FirebaseAuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.user$.pipe(
      take(1),
      switchMap(user => {
        if (!user) {
          return next.handle(req);
        }

        return from(user.getIdToken()).pipe(
          switchMap(token => {
            const authReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
                'x-original-authorization': `Bearer ${token}`, // For backend Firebase validation
              },
            });
            return next.handle(authReq);
          })
        );
      })
    );
  }
}
